import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  FontWeight,
  SMALL_DEVICE_MQ,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const cardDeliveryWarningClassName = css({
  alignItems: 'flex-start',
  display: 'flex',
});

export const mediaClassName = css({
  background: Colors.BrandLight,
  borderRadius: 4,
  padding: Spacing.SM,
});

export const iconClassName = css({
  color: Colors.Brand,
  '& svg': {
    height: 22,
    width: 22,
  },
});

export const textClassName = css({
  marginLeft: Spacing.MD,
});

export const titleClassName = css({
  color: Colors.Primary,
  fontSize: FontSize.REGULAR,
  fontWeight: FontWeight.SEMI_BOLD,
  [SMALL_DEVICE_MQ]: {
    fontWeight: FontWeight.MEDIUM,
  },
});

export const subtitleClassName = css({
  color: Colors.Secondary,
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.NORMAL,
  marginTop: Spacing.XS,
});
